import { useMutation } from '@tanstack/react-query'
import { aiInsightsApi } from '@/infrastructure/api/ai-insights/ai-insights'
import { AIInsightsApiPostAIInsightsFeedbackRequest } from '@itsrever/rever-api'

const postFeedback = async (
  req: AIInsightsApiPostAIInsightsFeedbackRequest
) => {
  const { data } = await aiInsightsApi.postAIInsightsFeedback(req)

  return data
}

export const useReturnRateInsightFeedback = () => {
  return useMutation({
    mutationFn: postFeedback
  })
}
